import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  analysisResults: Record<string, string>;
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  analysisResults: {},
  loading: false,
  error: null,
};

const imageAnalysisSlice = createSlice({
  name: "imageAnalysis",
  initialState,
  reducers: {
    analyzeImageRequest(state, action: PayloadAction<File>) {
      state.loading = true;
      state.error = null;
    },
    analyzeImageSuccess(
      state,
      action: PayloadAction<{ fileName: string; isClear: string }>
    ) {
      state.loading = false;
      state.analysisResults[action.payload.fileName] = action.payload.isClear;
    },
    analyzeImageFailure(
      state,
      action: PayloadAction<{ fileName: string; error: any }>
    ) {
      state.loading = false;
      state.analysisResults[action.payload.fileName] = "error";
    },
    setManualAnalysisResult(
      state,
      action: PayloadAction<{ fileName: string; result: string }>
    ) {
      state.analysisResults[action.payload.fileName] = action.payload.result;
    },
  },
});

export const {
  analyzeImageRequest,
  analyzeImageSuccess,
  analyzeImageFailure,
  setManualAnalysisResult,
} = imageAnalysisSlice.actions;

export default imageAnalysisSlice.reducer;
